<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title18"></a>
<div class="verse"><span><em class="i">There is, one knows not what sweet mystery about this sea, whose gently awful stirrings seem to speak of some hidden soul beneath …</em></span></div>
<div class="source"><span>—<em class="i">HERMAN MELVILLE</em></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466806597_epi01.vue?df20cdc2